import { ReactNode } from 'react'
import { useAuth } from '../../hooks/use-auth'
import { Navigate } from 'react-router'
import { RoutePath } from 'src/enums/routing'

export type ProtectedProps = {
  children: ReactNode
}

export function Protected({ children }: ProtectedProps) {
  const { isLoggedIn } = useAuth()

  return (
    <div>
      { isLoggedIn ? children : <Navigate to={RoutePath.Login} /> }
    </div>
  )
}
